// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-10-23T08:20:35Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Kontroler pro novou registraci, případně přiregistraci autentizace k již existujícímu účtu. Generated from cz.marbes.eosp.controller.RegistraceController.
 */
export default class RegistraceApi {
    /**
     * 
     *
     * @param key 
     * @param email 
     */
    static newRegistration(key, email) {
        const uri = serverContextPath + `/api/eosp/new-registration`;
        const headers = undefined;
        const params = { key, email };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param key 
     * @return cz.marbes.api.registrace.v1.NovaRegistraceMetadata
     */
    static getOidcUserInfo(key) {
        const uri = serverContextPath + `/api/eosp/oidc-user-info`;
        const headers = undefined;
        const params = { key };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Vrátí url adresu portálu s texty souhlasů. @return url
     *
     * @return java.lang.String
     */
    static getConsentsUrl() {
        const uri = serverContextPath + `/api/eosp/consent/url`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return java.lang.Boolean
     */
    static getEmailConfig() {
        const uri = serverContextPath + `/api/eosp/email/config`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param typSouhlasu 
     * @return cz.marbes.pbo.rest.pbo.v1.vo.TextSouhlasu2
     */
    static getTextSouhlasu(typSouhlasu) {
        const uri = serverContextPath + `/api/eosp/souhlasy/${typSouhlasu}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
